import React from "react";
import { Hash, MessageSquareText, Building2, Flag, Clock3, ChevronRight } from "lucide-react";
import { PriorityBadge, StatusBadge } from "./TicketBadge";
import "./ClientTicket.css";
import NoIndex from "../../components/NoIndex";
import { formatDateTime } from "../../utils/dateFormatter";

const STATUS_META = {
  O: { label: "Open", tone: "open" },
  P: { label: "In Progress", tone: "progress" },
  C: { label: "Closed", tone: "closed" },
};

const ClientTicketCard = ({ ticket, onOpen }) => {
  const status = String(ticket?.status || "O");
  const tone = (STATUS_META[status] || STATUS_META.O).tone;

  return (
    <>
    <NoIndex/>
    <div
      className={`client-tickets-card montserrat-font-1 client-tickets-tone-${tone}`}
      role="button"
      onClick={onOpen}
      title="Open ticket details"
    >
      {/* Top Row: subject + CTA */}
      <div className="client-tickets-card-top montserrat-font-1">
        <div className="client-tickets-card-title" title={ticket?.subject || ""}>
          <MessageSquareText size={16} />
          <span className="text-truncate">
            {ticket?.subject || "—"}
          </span>
        </div>
        <div className="client-tickets-card-cta montserrat-font-1">
          <span>Open</span>
          <ChevronRight size={16} />
        </div>
      </div>

      {/* Meta rows */}
      <div className="client-tickets-card-meta montserrat-font-1">
        <div className="client-tickets-meta-row montserrat-font-1">
          <div className="client-tickets-meta-item" title={ticket?.ticket_code || ""}>
            <Hash size={16} />
            <span className="label">Code</span>
            <span className="value">{ticket?.ticket_code || "—"}</span>
          </div>
          <div className="client-tickets-meta-item" title={ticket?.department || ""}>
            <Building2 size={16} />
            <span className="label">Department</span>
            <span className="value">{ticket?.department || "—"}</span>
          </div>
        </div>

        <div className="client-tickets-meta-row montserrat-font-1">
          <div className="client-tickets-meta-item" title={String(ticket?.priority || "")}>
            <Flag size={16} />
            <span className="label">Priority</span>
            <span className="value">
              <PriorityBadge value={ticket?.priority} />
            </span>
          </div>
          <div className="client-tickets-meta-item montserrat-font-1" title={ticket?.updated_on || ""}>
            <Clock3 size={16} />
            <span className="label">Updated</span>
           <span className="value">
  {formatDateTime(ticket?.updated_on, true)}
</span>
          </div>
        </div>
      </div>

      {/* Status badge sticks to bottom */}
      <div className="client-tickets-card-status montserrat-font-1">
        <StatusBadge code={ticket?.status} />
      </div>
    </div>
    </>
  );
};

export default ClientTicketCard;
